import Router from "../Modules/Router";

export default function App() {
  return (    
    <div className="App" style={{ height: '100%', width: '100%' }}>
      <Router></Router>      
    </div>
  );
}